import { LinkButton } from '@atlaskit/button/new';

import type { Action } from '../../../common/types';
import { useAnalyticsWebClient } from '../../../utils/analytics/context';

export const LinkActionButton = ({ action }: { action: Action }) => {
	const { link, target } = action?.href || {};
	const { label, analyticEvent } = action;
	const analyticsWebClient = useAnalyticsWebClient();

	const handleClick = () => {
		if (analyticEvent) {
			analyticsWebClient.sendUIEvent(analyticEvent);
		}
	};

	return (
		<LinkButton
			href={link || ''}
			appearance="subtle"
			spacing="compact"
			target={target || '_blank'}
			onClick={handleClick}
			testId={action.testId ? action.testId : undefined}
		>
			{label}
		</LinkButton>
	);
};
